import { User } from '@app/app/interfaces/user.model';
import { formatRelative } from 'date-fns';

export function relativeDate(timestamp: number, shouldCapitalize = false) {
  const relativeDate = formatRelative(new Date(timestamp * 1000), new Date());
  if (shouldCapitalize === false) {
    return relativeDate;
  }

  return relativeDate.charAt(0).toUpperCase() + relativeDate.slice(1);
}

export function userFullName(creatorUser: User) {
  return `${creatorUser?.first} ${creatorUser?.last}`;
}
